// components/common/JsonSchemaForm.jsx
import React from "react";
import Form from "@rjsf/core"; // o "@rjsf/mui" se vuoi styling Material UI
import validator from "@rjsf/validator-ajv8"; // raccomandato

function JsonSchemaForm({ schema, formData, onChange }) {
  if (!schema || !schema.properties) {
    return <p style={{ color: "#999" }}>Schema no disponible</p>;
  }

  return (
    <Form
      schema={schema}
      formData={formData}
      onChange={onChange}
      validator={validator}
      liveValidate
      noValidate 
    >
      {/* No submit interno */}
      <></>
    </Form>
  );
}

export default JsonSchemaForm;
